import { BasketUpdateItem } from 'graphql-api/baskets-api-interfaces';

export function updateOrAddInventoryByDate(
  items: BasketUpdateItem[],
  item: BasketUpdateItem,
) {
  const existing = items.find(
    (i) =>
      i.requestedDeliveryDate === item.requestedDeliveryDate &&
      i.inventoryId === item.inventoryId,
  );
  if (existing) {
    existing.requestedQuantity =
      existing?.requestedQuantity + item.requestedQuantity;
  } else {
    items.push(item);
  }
  return items;
}
